import { Survey, SurveyAnswerData, SurveyDemographicAnswerData } from './../../model/SurveyModel';

export interface SurveyState {
    loadingTeam: boolean;
    errorTeam: boolean;
    loadingOrganization: boolean;
    errorOrganization: boolean;
    teamSurveys: Array<Survey>;
    organizationSurveys: Array<Survey>;
    currentSurvey: Survey;
    loadingSurvey: boolean;
    errorSurvey: boolean;
    currentAnswers: Array<SurveyAnswerData>;
    loadingAnswer: boolean;
    errorAnswer: boolean;
    currentDemographicAnswers: Array<SurveyDemographicAnswerData>;
    loadingDemographicAnswer: boolean;
    errorDemographicAnswer: boolean;
    loadingSaveAnswer: boolean;
    errorSaveAnswer: boolean;
    loadingSaveDemographicAnswer: boolean;
    errorSaveDemographicAnswer: boolean;
}

export const initialState: SurveyState = {
    loadingTeam: false,
    errorTeam: false,
    loadingOrganization: false,
    errorOrganization: false,
    teamSurveys: [],
    organizationSurveys: [],
    currentSurvey: null,
    loadingSurvey: false,
    errorSurvey: false,
    currentAnswers: null,
    loadingAnswer: false,
    errorAnswer: false,
    currentDemographicAnswers: null,
    loadingDemographicAnswer: false,
    errorDemographicAnswer: false,
    loadingSaveAnswer: false,
    errorSaveAnswer: false,
    loadingSaveDemographicAnswer: false,
    errorSaveDemographicAnswer: false
}


// WEBPACK FOOTER //
// ./src/store/state/SurveyState.ts